import { useRouter } from "next/router";
import {
  CarDetailsContainer,
  CheckoutCardWrapper,
  PolicyStartDate
} from "./styles";
import DOMPurify from "isomorphic-dompurify";
import { Flex, Box } from "@acko-tech/building-blocks.ui.common";
import ImageContainer from "@components/imageContainer";
import { resolvePath } from "@utils/resolvePath";
import Hyperlink from "@components/common/hyperlink";

const CheckoutCard = ({ children, ...props }) => {
  const {
    isPiRequired,
    piText,
    regNo,
    owner,
    displayText,
    actions,
    product
  } = props || {};

  const shadowStyle = {
    width: "100%",
    height: "auto",
    display: "block",
    boxShadow:
      "-5px 0 5px -5px rgba(61, 57, 82, 0.08), 5px 0 5px -5px rgba(61, 57, 82, 0.08)"
  };

  const { on_click } = actions || {};
  const iconSrc =
    product === "bike"
      ? "https://storefront-consumer-assets.s3.ap-south-1.amazonaws.com/static/sdui-prequote/bike_insurance.svg"
      : "https://storefront-consumer-assets.s3.ap-south-1.amazonaws.com/static/sdui-prequote/car_insurance.svg";

  return (
    <Box>
      <Box width="100%">
        <img
          src={resolvePath("/images/top.svg")}
          alt="top"
          style= {shadowStyle}
        />
      </Box>

      <CheckoutCardWrapper>
        <CarDetailsContainer>
          <ImageContainer
            imgSrc={iconSrc}
            width={48}
            height={48}
            alt={"car details"}
          />
          <Flex flexDirection="column" style={{ gap: "2px" }}>
            <div
              style={{
                fontSize: "14px",
                fontWeight: "500",
                lineHeight: "18px",
                color: "#040222"
              }}
            >
              {regNo}
            </div>
            <div
              style={{ color: "#5B5675", fontSize: "12px", fontWeight: "400" }}
            >
              {owner
                ? owner
                    .split(" ")
                    .map(
                      (word) =>
                        word.charAt(0).toUpperCase() +
                        word.slice(1).toLowerCase()
                    )
                    .join(" ")
                : ""}
            </div>
          </Flex>
        </CarDetailsContainer>
        <PolicyStartDate>
          {isPiRequired ? (
            <div>
              <div>{piText}</div>
              <Hyperlink
                clickHandler={() => {
                  if (on_click?.length > 0) {
                    on_click?.forEach((eachFunc: any) => {
                      if (typeof eachFunc.funCall === "function") {
                        eachFunc.funCall(eachFunc.args);
                      }
                    });
                  }
                }}
                is_visible={true}
                text="Know more"
                type="UNDERLINE"
                styles={{
                  display: "inline-block",
                  width: "max-content",
                  color: "#36354C",
                  fontWeight: "500"
                }}
              />
            </div>
          ) : (
            <>
              <div
                style={{
                  fontSize: "14px",
                  color: "#5B5675",
                  marginLeft: "4px",
                  width: "80%"
                }}
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(displayText)
                }}
              ></div>
            </>
          )}
        </PolicyStartDate>
        <CarDetailsContainer style={{ flexDirection: "column", gap: "0px" }}>
          {children}
        </CarDetailsContainer>
      </CheckoutCardWrapper>

      <Box width="100%">
        <img
          src={resolvePath("/images/bottom.svg")}
          alt="bottom"
          style= {shadowStyle}
        />
      </Box>
    </Box>
  );
};

export default CheckoutCard;